/*
JTM - fabric product builder button menu links - scripts
- builder buttons (NEW)
- only main JS
- window collection obj in liquid file 'ecs_builder-buttons-on-fabric-product-pages.liquid'
*/

/*
JTM - fabric product builder button menu links - scripts
- builder buttons (NEW)
- only main JS
- window collection obj in liquid file 'ecs_builder-buttons-on-fabric-product-pages.liquid'
*/

(() => {
/* Fabric Product Builder Button Links */

if (document.querySelector('#builder-buttons-box')) {
    document.documentElement.classList.add('has-builder-buttons');
}
/*
  available page transition effects:
  fbl-page-transition-fade-lift
  fbl-page-transition-fade
  fbl-page-transition-lift
  fbl-page-transition-scale-soften
*/
/* const pageTransitionEffect = "fbl-page-transition-fade-lift";
const list = document.documentElement.classList;
const isFabricProductPage =  (list.contains("has-builder-buttons") && list.contains("is-csr"));
const isBuilderProductPage = (list.contains("is-builder") && list.contains("is-csr"));
if(list.contains("is-products")){
  if (isFabricProductPage || isBuilderProductPage) {
    list.add(pageTransitionEffect);
  }
} */
/* ------------------------------------------------- */

function waitForElm2(selector, disconnect) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) return resolve(document.querySelector(selector));
    const observer = new MutationObserver(mutations => { if (document.querySelector(selector)) { resolve(document.querySelector(selector)); if (disconnect === true) observer.disconnect() } });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true})
  })
}
waitForElm2('#builder-buttons-box .fabric-builder-links__grid > ul li', true).then((elm) => {

    const fabricBuilderLinksConfig = {
      allowMultipleOpenCards: false,
      builderFabricQueryParam: "builder_fabric",
      mobileExpandedMaxWidth: 480,//768
      allowFloatingOnMobile: true,
      floatingMenuGap: 10,
      floatingMenuViewportPadding: 12,
      floatingMenuPosition: "auto", // "auto", "north", "south", "center"
      closeFloatingMenuOnScroll: true,
      closeFloatingMenuOnResize: true,
      containFloatingMenuWheelScroll: true,
      builderProductFilterKeywords: ["Textilene","Rain"],
      builderProductFilterKeywordsException: {
        Rain: {
          builderButtons: ["Cushion Builder"]
        }
      },
    };

    const demoBuilderGroups = [
      {
        key: "cushion",
        label: "Build a Cushion",
        builderButton: "Cushion Builder",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-seat-cushion"><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M3 14v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3" /></svg>',
        collectionHandle: "custom-cushion-builders"
      },
      {
        key: "pillow",
        label: "Build a Pillow",
        builderButton: "Pillow Builder",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-throw-pillow"><path d="M5 5 Q12 2 19 5 Q22 12 19 19 Q12 22 5 19 Q2 12 5 5"></path><path d="M5 5l2.5 2.5"></path><path d="M19 5l-2.5 2.5"></path><path d="M19 19l-2.5-2.5"></path><path d="M5 19l2.5-2.5"></path></svg>',
        collectionHandle: "custom-pillow-builders"
      },
      {
        key: "curtain",
        label: "Build a Curtain",
        builderButton: "Curtain Builder",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="icon"><rect x="2" y="3" width="2" height="6" rx="1"></rect><rect x="20" y="3" width="2" height="6" rx="1"></rect><rect x="4" y="5" width="16" height="2"></rect><polygon points="4,8 9,8 9,22 4,20.5"></polygon><polygon points="9.5,8 14.5,8 14.5,22 9.5,20.5"></polygon><polygon points="15,8 20,8 20,22 15,20.5"></polygon></svg>',
        collectionHandle: "custom-curtain-builders"
      },
      {
        key: "panel",
        label: "Build a Panel",
        builderButton: "Panel Builder",
        icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /></svg>',
        collectionHandle: "custom-panel-builders"
      }
    ];

    const demoBuilderCollections = {
      "custom-cushion-builders": [
        {
          title: "Chair Cushions",
          url: "/products/chair-cushion-builder",
          sku: "BLD-CUSH-CHAIR",
          status: "active"
        },
        {
          title: "Daybed Cushions",
          url: "/products/daybed-cushion-builder",
          sku: "BLD-CUSH-DAYBED",
          status: "active"
        },
        {
          title: "Glider Cushions",
          url: "/products/glider-cushion-builder",
          sku: "BLD-CUSH-GLIDER",
          status: "active"
        },
        {
          title: "Loveseat Cushions",
          url: "/products/loveseat-cushion-builder",
          sku: "BLD-CUSH-LOVESEAT",
          status: "active"
        },
        {
          title: "Sofa Cushions",
          url: "/products/sofa-cushion-builder",
          sku: "BLD-CUSH-SOFA",
          status: "active"
        },
        {
          title: "Breakfast Nook Cushions",
          url: "/products/breakfast-nook-cushion-builder",
          sku: "BLD-CUSH-NOOK",
          status: "active"
        },
        {
          title: "Bench / Window Cushions",
          url: "/products/bench-window-cushion-builder",
          sku: "BLD-CUSH-BENCH",
          status: "active"
        },
        {
          title: "Barstool Cushions",
          url: "/products/barstool-cushion-builder",
          sku: "BLD-CUSH-BARSTOOL",
          status: "active"
        },
        {
          title: "Ottoman Cushions",
          url: "/products/ottoman-cushion-builder",
          sku: "BLD-CUSH-OTTOMAN",
          status: "active"
        },
        {
          title: "Draft Test Cushions",
          url: "/products/draft-test-cushion-builder",
          sku: "BLD-CUSH-DRAFT",
          status: "draft"
        }
      ],

      "custom-pillow-builders": [
        {
          title: "Standard Size Pillows",
          url: "/products/standard-size-pillow-builder",
          sku: "BLD-PILLOW-STANDARD",
          status: "active"
        },
        {
          title: "Custom Odd Size Pillows",
          url: "/products/custom-odd-size-pillow-builder",
          sku: "BLD-PILLOW-CUSTOM",
          status: "active"
        },
        {
          title: "Bolster Pillows",
          url: "/products/bolster-pillow-builder",
          sku: "BLD-PILLOW-BOLSTER",
          status: "active"
        }
      ],

      "custom-curtain-builders": [
        {
          title: "Grommet Top Curtains",
          url: "/products/grommet-top-curtain-builder",
          sku: "BLD-CURTAIN-GROMMET",
          status: "active"
        },
        {
          title: "Back Tab Curtains",
          url: "/products/back-tab-curtain-builder",
          sku: "BLD-CURTAIN-BACKTAB",
          status: "active"
        },
        {
          title: "Rod Pocket Curtains",
          url: "/products/rod-pocket-curtain-builder",
          sku: "BLD-CURTAIN-RODPOCKET",
          status: "active"
        },
        {
          title: "Tab Top Curtains",
          url: "/products/tab-top-curtain-builder",
          sku: "BLD-CURTAIN-TABTOP",
          status: "active"
        }
      ],

      "custom-panel-builders": [
        {
          title: "Grommet Panels",
          url: "/products/grommet-panel-builder",
          sku: "BLD-PANEL-GROMMET",
          status: "active"
        },
        {
          title: "Snap Fastener Panels",
          url: "/products/snap-fastener-panel-builder",
          sku: "BLD-PANEL-SNAP",
          status: "active"
        },
        {
          title: "Side Pocket Panels",
          url: "/products/side-pocket-panel-builder",
          sku: "BLD-PANEL-SIDEPOCKET",
          status: "active"
        }
      ]
    };

    function initFabricBuilderLinks() {
      document.querySelectorAll("[data-fabric-builder-links]").forEach(function (root) {
        const grid = root.querySelector("[data-builder-card-grid]");

        if (!grid) {
          return;
        }

        const builderButtonSlots = grid.querySelectorAll("ul li[data-builder-button]");

        if (builderButtonSlots.length) {
          builderButtonSlots.forEach(function (slot) {
            slot.innerHTML = "";
          });
        } else {
          grid.innerHTML = "";
        }

        getBuilderGroups().forEach(function (group) {
          const builderButtonSlot = findBuilderButtonSlot(grid, group);
          if (!builderButtonSlot) {
            return;
          }

          const products = getActiveBuilderProducts(group.collectionHandle, root, group);

          if (!products.length) {
            return;
          }

          const card = createBuilderCard(root, group, products, builderButtonSlot);

          builderButtonSlot.appendChild(card);
        });

        updateFabricBuilderLinksMode(root);
      });

      document.addEventListener("keydown", handleBuilderCardKeydown);
      document.addEventListener("click", handleBuilderCardDocumentClick);
      document.addEventListener("focusin", handleBuilderCardDocumentFocusIn);
      window.addEventListener("resize", handleBuilderCardResize);
      window.addEventListener("scroll", handleBuilderCardScroll, true);
      document.addEventListener("wheel", handleFloatingBuilderMenuWheel, { passive: false });
    }

    function isFabricBuilderLinksDemoMode() {
      return !!document.querySelector("#is-demo");
    }

    function getBuilderGroups() {
      if (isFabricBuilderLinksDemoMode()) {
        return demoBuilderGroups;
      }

      if (window.fabricBuilderLinksData && Array.isArray(window.fabricBuilderLinksData.builderGroups)) {
        return window.fabricBuilderLinksData.builderGroups;
      }

      return [];
    }

    function getBuilderCollections() {
      if (isFabricBuilderLinksDemoMode()) {
        return demoBuilderCollections;
      }

      if (window.fabricBuilderLinksData && window.fabricBuilderLinksData.builderCollections) {
        return window.fabricBuilderLinksData.builderCollections;
      }

      return {};
    }

    function getActiveBuilderProducts(collectionHandle, root, group) {
      const builderCollections = getBuilderCollections();
      const products = builderCollections[collectionHandle] || [];

      return products.filter(function (product) {
        return product.status === "active";
      }).filter(function (product) {
        return isAllowedBuilderProductForCurrentProduct(product, root, group);
      });
    }

    function isAllowedBuilderProductForCurrentProduct(product, root, group) {
      const currentProductKeywordMatches = getBuilderProductFilterKeywordMatches(getCurrentProductTitle(root));
      const builderProductKeywordMatches = getBuilderProductFilterKeywordMatches(getBuilderProductFilterText(product));

      if (!currentProductKeywordMatches.length) {
        return !builderProductKeywordMatches.length;
      }

      const hasAllowedCurrentProductKeywordException = currentProductKeywordMatches.some(function (keyword) {
        return isAllowedBuilderProductFilterKeywordException(keyword, group);
      });

      if (hasAllowedCurrentProductKeywordException) {
        return true;
      }

      if (!builderProductKeywordMatches.length) {
        return false;
      }

      return builderProductKeywordMatches.some(function (keyword) {
        return currentProductKeywordMatches.includes(keyword);
      });
    }

    function isAllowedBuilderProductFilterKeywordException(keyword, group) {
      const keywordException = getBuilderProductFilterKeywordException(keyword);

      if (!keywordException) {
        return true;
      }

      if (Array.isArray(keywordException.builderButtons) && keywordException.builderButtons.length) {
        return keywordException.builderButtons.includes(group.builderButton);
      }

      return true;
    }

    function getBuilderProductFilterKeywordException(keyword) {
      const exceptions = fabricBuilderLinksConfig.builderProductFilterKeywordsException || {};
      const matchedExceptionKey = Object.keys(exceptions).find(function (exceptionKeyword) {
        return exceptionKeyword.toLowerCase() === String(keyword || "").toLowerCase();
      });

      return matchedExceptionKey ? exceptions[matchedExceptionKey] : null;
    }

    function getCurrentProductTitle(root) {
      const builderButtonsBox = root || document.querySelector("#builder-buttons-box");

      if (!builderButtonsBox || !builderButtonsBox.dataset) {
        return "";
      }

      return builderButtonsBox.dataset.productTitle || "";
    }

    function getBuilderProductFilterText(product) {
      if (!product) {
        return "";
      }

      return [
        product.title || "",
        product.originalTitle || "",
        product.subtitle || "",
        product.filterText || ""
      ].join(" ");
    }

    function getBuilderProductFilterKeywordMatches(text) {
      return fabricBuilderLinksConfig.builderProductFilterKeywords.filter(function (keyword) {
        const keywordPattern = new RegExp("\\b" + escapeRegExp(keyword) + "\\b", "i");

        return keywordPattern.test(String(text || ""));
      });
    }

    function escapeRegExp(value) {
      return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    function findBuilderButtonSlot(grid, group) {
      if (!grid || !group) {
        return null;
      }

      return Array.from(grid.querySelectorAll("ul li[data-builder-button]")).find(function (slot) {
        return slot.dataset.builderButton === group.builderButton;
      }) || null;
    }

    function createBuilderCard(root, group, products, dataSource) {
      const card = document.createElement("div");
      const triggerId = "builder-card-trigger-" + group.key;
      const panelId = "builder-card-panel-" + group.key;

      card.className = "builder-card";
      card.dataset.builderCard = group.key;

      card.innerHTML = `
        <a
          class="builder-card__trigger"
          href="#${panelId}"
          id="${triggerId}"
          rel="nofollow" 
          role="button"
          aria-expanded="false"
          aria-controls="${panelId}"
          data-builder-card-trigger
        >
          <span class="builder-card__trigger-main">
            <span class="builder-card__icon" aria-hidden="true">${group.icon}</span>
            <span>
              <span class="builder-card__label">${escapeHtml(group.label)}</span>
              <span class="builder-card__count">${products.length} option${products.length === 1 ? "" : "s"}</span>
            </span>
          </span>

          <span class="builder-card__chevron" aria-hidden="true"><i><svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M20 8.5 12.5 16 5 8.5" stroke="currentColor" stroke-width="1.5" fill="none"></path></svg></i></span>
        </a>

        <div
          class="builder-card__panel"
          id="${panelId}"
          data-builder-card-panel
        >
          <div class="builder-card__panel-inner">
            <div class="builder-card__list" data-builder-card-list></div>
          </div>
        </div>
      `;

      const trigger = card.querySelector("[data-builder-card-trigger]");
      const list = card.querySelector("[data-builder-card-list]");
      
      renderBuilderCardLinks(root, list, products, dataSource);

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        toggleBuilderCard(card);
      });

      return card;
    }

    function renderBuilderCardLinks(root, list, products, dataSource) {
      list.innerHTML = "";

      if (!products.length) {
        const empty = document.createElement("div");
        empty.className = "builder-card__empty";
        empty.textContent = "No active builder products are available right now.";
        list.appendChild(empty);
        return;
      }

      products.forEach(function (product) {
        const link = document.createElement("a");

        link.className = "builder-card__link builder-link";
        link.href = buildBuilderProductUrl(root, product, dataSource);
        link.setAttribute('rel','nofollow');
        link.dataset.builderProductSku = product.sku || "";
        link.dataset.builderProductTitle = product.title || "";

        link.innerHTML = `
          <span class="builder-card__product-title">${escapeHtml(product.title)}</span>
          <span class="builder-card__arrow" aria-hidden="true"><i>→</i></span>
        `;

        list.appendChild(link);
      });
    }

    function buildBuilderProductUrl(root, product, dataSource) {
      const url = new URL(product.url, window.location.origin);
      const fabricDataSource = dataSource || root;
      const fabricSkuNumber = getFabricSkuNumber(fabricDataSource);

      url.search = "";

      if (fabricSkuNumber) {
        url.searchParams.set(fabricBuilderLinksConfig.builderFabricQueryParam, fabricSkuNumber);
      }

      return url.pathname + url.search;
    }

    function getFabricSkuNumber(fabricDataSource) {
      if (!fabricDataSource || !fabricDataSource.dataset) {
        return "";
      }

      const fabricSkuValue = fabricDataSource.dataset.fabricSku || fabricDataSource.dataset.fabricNameSku || "";
      const fabricSkuMatch = String(fabricSkuValue).match(/\d+/);

      return fabricSkuMatch ? fabricSkuMatch[0] : "";
    }

    function toggleBuilderCard(card) {
      const isOpen = card.classList.contains("is-open");

      if (!fabricBuilderLinksConfig.allowMultipleOpenCards) {
        closeAllBuilderCards(card);
      }

      if (isOpen) {
        closeBuilderCard(card);
      } else {
        openBuilderCard(card);
      }
    }

    function openBuilderCard(card) {
      const trigger = card.querySelector("[data-builder-card-trigger]");
      const root = card.closest("[data-fabric-builder-links]");

      if (trigger) {
        trigger.setAttribute("aria-expanded", "true");
      }

      if (root && isFloatingBuilderMode(root)) {
        card.classList.remove("is-floating-ready");
        positionFloatingBuilderPanel(card);

        requestAnimationFrame(function () {
          card.classList.add("is-open", "is-floating-ready");
        });

        return;
      }

      card.classList.add("is-open");
    }

    function closeBuilderCard(card) {
      const trigger = card.querySelector("[data-builder-card-trigger]");
      const panel = card.querySelector("[data-builder-card-panel]");
      const root = card.closest("[data-fabric-builder-links]");

      clearActiveBuilderCardLinks(card);
      card.classList.remove("is-open", "is-floating-ready");

      if (trigger) {
        trigger.setAttribute("aria-expanded", "false");
      }

      if (root && root.classList.contains("is-floating-mode")) {
        scheduleFloatingBuilderPanelCleanup(card, panel, root);
        return;
      }

      if (panel) {
        panel.style.removeProperty("--fbl-floating-menu-left");
        panel.style.removeProperty("--fbl-floating-menu-top");
        panel.style.removeProperty("--fbl-floating-menu-width");
        panel.style.removeProperty("--fbl-floating-menu-max-height");
      }

      if (root) {
        root.classList.remove("is-floating-north", "is-floating-south", "is-floating-center");
      }
    }

    function scheduleFloatingBuilderPanelCleanup(card, panel, root) {
      if (!panel) {
        return;
      }

      window.setTimeout(function () {
        if (card.classList.contains("is-open")) {
          return;
        }

        panel.style.removeProperty("--fbl-floating-menu-left");
        panel.style.removeProperty("--fbl-floating-menu-top");
        panel.style.removeProperty("--fbl-floating-menu-width");
        panel.style.removeProperty("--fbl-floating-menu-max-height");

        if (root && !root.querySelector("[data-builder-card].is-open")) {
          root.classList.remove("is-floating-north", "is-floating-south", "is-floating-center");
        }
      }, fabricBuilderLinksConfig.floatingCloseCleanupDelay || 260);
    }

    function closeAllBuilderCards(exceptCard) {
      document.querySelectorAll("[data-builder-card].is-open").forEach(function (card) {
        if (card === exceptCard) {
          return;
        }

        closeBuilderCard(card);
      });
    }

    function handleBuilderCardKeydown(event) {
      const openCard = document.querySelector("[data-builder-card].is-open");

      if (event.key === "Escape") {
        closeAllBuilderCards();
        return;
      }

      if (!openCard) {
        return;
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();
        focusBuilderCardLink(openCard, 1);
        return;
      }

      if (event.key === "ArrowUp") {
        event.preventDefault();
        focusBuilderCardLink(openCard, -1);
        return;
      }

      if (event.key === "Enter") {
        activateFocusedBuilderCardLink(openCard);
      }
    }

    function focusBuilderCardLink(card, direction) {
      const links = getBuilderCardLinks(card);

      if (!links.length) {
        return;
      }

      const activeElement = document.activeElement;
      const activeIndex = links.indexOf(activeElement);
      let nextIndex = 0;

      if (activeIndex > -1) {
        nextIndex = activeIndex + direction;
      } else if (direction < 0) {
        nextIndex = links.length - 1;
      }

      if (nextIndex < 0) {
        nextIndex = links.length - 1;
      }

      if (nextIndex >= links.length) {
        nextIndex = 0;
      }

      setActiveBuilderCardLink(links[nextIndex]);
    }

    function activateFocusedBuilderCardLink(card) {
      const links = getBuilderCardLinks(card);
      const activeLink = links.find(function (link) {
        return link === document.activeElement || link.classList.contains("is-keyboard-active");
      });

      if (!activeLink) {
        return;
      }

      activeLink.click();
    }

    function setActiveBuilderCardLink(activeLink) {
      const card = activeLink.closest("[data-builder-card]");

      if (!card) {
        return;
      }

      clearActiveBuilderCardLinks(card);
      activeLink.classList.add("is-keyboard-active");
      activeLink.focus({ preventScroll: true });
      activeLink.scrollIntoView({ block: "nearest" });
    }

    function clearActiveBuilderCardLinks(card) {
      card.querySelectorAll(".builder-card__link.is-keyboard-active").forEach(function (link) {
        link.classList.remove("is-keyboard-active");
      });
    }

    function getBuilderCardLinks(card) {
      return Array.from(card.querySelectorAll(".builder-card__link"));
    }

    function handleBuilderCardDocumentClick(event) {
      const activeCard = event.target.closest("[data-builder-card].is-open");

      if (activeCard) {
        return;
      }

      closeAllBuilderCards();
    }

    function handleBuilderCardDocumentFocusIn(event) {
      const activeCard = event.target.closest("[data-builder-card].is-open");

      if (activeCard) {
        return;
      }

      closeAllBuilderCards();
    }

    function handleBuilderCardResize() {
      document.querySelectorAll("[data-fabric-builder-links]").forEach(function (root) {
        updateFabricBuilderLinksMode(root);

        if (fabricBuilderLinksConfig.closeFloatingMenuOnResize) {
          closeAllBuilderCards();
          return;
        }

        root.querySelectorAll("[data-builder-card].is-open").forEach(function (card) {
          if (isFloatingBuilderMode(root)) {
            positionFloatingBuilderPanel(card);
          }
        });
      });
    }

    function handleBuilderCardScroll(event) {
      if (isFloatingBuilderMenuScrollEvent(event)) {
        return;
      }

      if (fabricBuilderLinksConfig.closeFloatingMenuOnScroll) {
        document.querySelectorAll("[data-fabric-builder-links].is-floating-mode [data-builder-card].is-open").forEach(function (card) {
          closeBuilderCard(card);
        });

        return;
      }

      document.querySelectorAll("[data-fabric-builder-links].is-floating-mode [data-builder-card].is-open").forEach(function (card) {
        positionFloatingBuilderPanel(card);
      });
    }

    function isFloatingBuilderMenuScrollEvent(event) {
      if (!event || !event.target || !event.target.closest) {
        return false;
      }

      return !!event.target.closest("[data-fabric-builder-links].is-floating-mode [data-builder-card].is-open [data-builder-card-list]");
    }

    function handleFloatingBuilderMenuWheel(event) {
      if (!fabricBuilderLinksConfig.containFloatingMenuWheelScroll) {
        return;
      }

      const list = event.target.closest("[data-fabric-builder-links].is-floating-mode [data-builder-card].is-open [data-builder-card-list]");

      if (!list) {
        return;
      }

      const deltaY = event.deltaY;
      const maxScrollTop = list.scrollHeight - list.clientHeight;
      const isScrollable = maxScrollTop > 0;

      if (!isScrollable) {
        event.preventDefault();
        return;
      }

      const isAtTop = list.scrollTop <= 0;
      const isAtBottom = list.scrollTop >= maxScrollTop - 1;
      const scrollingUp = deltaY < 0;
      const scrollingDown = deltaY > 0;

      if ((isAtTop && scrollingUp) || (isAtBottom && scrollingDown)) {
        event.preventDefault();
      }
    }

    function updateFabricBuilderLinksMode(root) {
      const isMobileWidth = window.matchMedia("(max-width: " + fabricBuilderLinksConfig.mobileExpandedMaxWidth + "px)").matches;
      const isExpandedMode = isMobileWidth && !fabricBuilderLinksConfig.allowFloatingOnMobile;

      root.classList.toggle("is-expanded-mode", isExpandedMode);
      root.classList.toggle("is-floating-mode", !isExpandedMode);
      root.classList.toggle("is-mobile-floating-allowed", isMobileWidth && fabricBuilderLinksConfig.allowFloatingOnMobile);

      if (isExpandedMode) {
        root.classList.remove("is-floating-north", "is-floating-south", "is-floating-center");

        root.querySelectorAll("[data-builder-card-panel]").forEach(function (panel) {
          panel.style.removeProperty("--fbl-floating-menu-left");
          panel.style.removeProperty("--fbl-floating-menu-top");
          panel.style.removeProperty("--fbl-floating-menu-width");
          panel.style.removeProperty("--fbl-floating-menu-max-height");
        });
      }
    }

    function isFloatingBuilderMode(root) {
      updateFabricBuilderLinksMode(root);

      return root.classList.contains("is-floating-mode");
    }

    function positionFloatingBuilderPanel(card) {
      const root = card.closest("[data-fabric-builder-links]");
      const trigger = card.querySelector("[data-builder-card-trigger]");
      const panel = card.querySelector("[data-builder-card-panel]");

      if (!root || !trigger || !panel) {
        return;
      }

      const cardRect = card.getBoundingClientRect();
      const triggerRect = trigger.getBoundingClientRect();
      const viewportPadding = fabricBuilderLinksConfig.floatingMenuViewportPadding;
      const menuGap = fabricBuilderLinksConfig.floatingMenuGap;
      const menuPosition = fabricBuilderLinksConfig.floatingMenuPosition || "auto";
      const menuWidth = Math.max(triggerRect.width, 250);
      const maxViewportLeft = window.innerWidth - viewportPadding - menuWidth;
      const viewportLeft = Math.min(Math.max(triggerRect.left, viewportPadding), maxViewportLeft);
      const relativeLeft = viewportLeft - cardRect.left;
      const panelHeight = getFloatingBuilderPanelHeight(panel);
      const spaceBelow = Math.max(0, window.innerHeight - triggerRect.bottom - viewportPadding - menuGap);
      const spaceAbove = Math.max(0, triggerRect.top - viewportPadding - menuGap);
      const opensCenter = menuPosition === "center";
      const opensSouth = menuPosition === "south" || (menuPosition === "auto" && (spaceBelow >= panelHeight || spaceBelow >= spaceAbove));
      const opensNorth = menuPosition === "north" || (!opensCenter && !opensSouth);
      const maxAvailableMenuHeight = Math.max(120, window.innerHeight - (viewportPadding * 2));
      const availableMenuHeight = opensCenter ? maxAvailableMenuHeight : Math.max(120, opensSouth ? spaceBelow : spaceAbove);
      const fittedPanelHeight = Math.min(panelHeight, availableMenuHeight);
      let viewportTop = triggerRect.bottom + menuGap;

      if (opensCenter) {
        viewportTop = triggerRect.top + (triggerRect.height / 2) - (fittedPanelHeight / 2);
        viewportTop = Math.min(Math.max(viewportTop, viewportPadding), window.innerHeight - viewportPadding - fittedPanelHeight);
      } else if (opensNorth) {
        viewportTop = triggerRect.top - fittedPanelHeight - menuGap;
      }

      const relativeTop = opensCenter ? (viewportTop - cardRect.top) : (!opensSouth ? ((viewportTop - cardRect.top) + 10) : ((viewportTop - cardRect.top) - 10));

      root.classList.toggle("is-floating-center", opensCenter);
      root.classList.toggle("is-floating-south", opensSouth);
      root.classList.toggle("is-floating-north", opensNorth);

      panel.style.setProperty("--fbl-floating-menu-left", relativeLeft + "px");
      panel.style.setProperty("--fbl-floating-menu-top", relativeTop + "px");
      panel.style.setProperty("--fbl-floating-menu-width", menuWidth + "px");
      panel.style.setProperty("--fbl-floating-menu-max-height", availableMenuHeight + "px");
    }

    function getFloatingBuilderPanelHeight(panel) {
      const panelInner = panel.querySelector(".builder-card__panel-inner");

      if (!panelInner) {
        return panel.scrollHeight;
      }

      return panelInner.offsetHeight || panelInner.scrollHeight;
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    document.addEventListener("DOMContentLoaded", initFabricBuilderLinks);

});

})(); // IIFE